import { render, staticRenderFns } from "./header_component.vue?vue&type=template&id=5f77fabb&"
import script from "./header_component.vue?vue&type=script&lang=js&"
export * from "./header_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "header_component.vue"
export default component.exports